import { render, staticRenderFns } from "./LocalePreferenceModal.vue?vue&type=template&id=59bf2c9b&scoped=true"
import script from "./LocalePreferenceModal.vue?vue&type=script&lang=js"
export * from "./LocalePreferenceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bf2c9b",
  null
  
)

export default component.exports